import { decryptURLConditionalRedirection, decryptUrl } from "api/UrlEncryption";
import { checkLinkForExpiryBasedOnID } from "api/configuration";
import { userAuth } from "api/userAuth";
import { LOGIN_ROUTE } from "constants/routes";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, } from "react-router-dom";
import { setIsAPILoadingForLinkExpiryValidation } from "redux/conditionalRendering";
import { clearUrlId, setUrlId } from "redux/urlEncryption";
import { checkTokenExists } from "api/userAuth";

const Decryption = (props) => {
  const { route } = props;
  const params = useParams();
  const { component: Component } = route;
  const obj = new Object();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo)
  dispatch(clearUrlId())
  const userParams = Object.keys(params);

  const search = window.location.search;
  const refUrl = window.location.href
  const query = new URLSearchParams(search);
  const queryLinkBy = query.get("token");
  useEffect(() => {
    if (queryLinkBy) {
      dispatch(setIsAPILoadingForLinkExpiryValidation(true));

      dispatch(
        checkLinkForExpiryBasedOnID({ _id: queryLinkBy })
      )
        .unwrap()
        .then((result) => {
          if (result?.data?.status === "failure") {
            navigate("/error", {
              state: {
                header: "Link expired",
                body: "The Link you are trying to access has been expired. ",
                isLinkExpired: true,
              },
            });
          }
          dispatch(setIsAPILoadingForLinkExpiryValidation(false));

        });
    } else {
      dispatch(setIsAPILoadingForLinkExpiryValidation(false));
    }
  }, [queryLinkBy]);
  useEffect(async () => {
    if (route?.isPrivate) {
      if (sessionStorage.getItem("userToken")) {
        let userToken = JSON.parse(sessionStorage.getItem("userToken"));
        let res =await checkTokenExists(userToken)
        if(res.status.toLowerCase() ==="success"){
          window.location.href = LOGIN_ROUTE
        }else{
          localStorage.setItem("userToken", sessionStorage.getItem("userToken"))          
        }
      }
      if (localStorage.getItem("userToken") === null) {
        if( window.location.href !== LOGIN_ROUTE){
          window.location.href = `${LOGIN_ROUTE}?redirect=${refUrl}`
        }else{
          window.location.href = LOGIN_ROUTE
        }
      }
    }
  }, [])


  if (route?.isPrivate) {
    if (sessionStorage.getItem("userToken")) {
      localStorage.setItem("userToken", sessionStorage.getItem("userToken"))
    }
    if (localStorage.getItem("userToken") === null) {
      window.location.href = LOGIN_ROUTE
    } else {
      if (Object.keys(loggedInUserInfo).length <= 0) {
        let user = JSON.parse(localStorage.getItem('userToken'));
        let params = {
          loggedInUser: JSON.parse(localStorage.getItem('userToken')),
          ipInfo: localStorage.getItem('ipInfo'),
          auth_token: localStorage.getItem('sessionToken'),
          user_id : user?.userId
        }
        
        console.log("🚀 ~ Decryption ~ params:", params)
        dispatch(userAuth(params))
      }
    }
  }

  if (!route?.decrypt) {
    userParams.forEach((item) => {
      dispatch(setUrlId({ key: item, value: params[item] }));
    });
    return <Component />;
  } else if (route?.decrypt) {
    userParams.forEach(async (item) => {
      if (item === "redirectionConfigId") {
        await dispatch(decryptURLConditionalRedirection({ key: item, value: params[item] })).unwrap()
      } else await dispatch(decryptUrl({ key: item, value: params[item] })).unwrap()
    });
    return <Component />;
  }
};

export default Decryption;
